import LoginService, { isLoggedIn, logout } from "./login/loginService";
import urlConfig from "../../config/domain";
import { ASaveQueryData } from "./login/loginApiService";

export function handleSessionTimeout(newResp: Response, res: any) {
	if (
		newResp.status === 403 ||
		(newResp.status === 401 && isLoggedIn()) ||
		(newResp.status === 200 && res.response && res.response.infoID === "EPS0008")
	) {
		logout();

		if (sessionStorage.getItem("source")) {
			sessionStorage.removeItem("source");
			sessionStorage.removeItem("sourceToken");
		}

		let queryString;
		if (window.location.href.indexOf(urlConfig.root + "login") > -1) {
			queryString = {
				reUrl: LoginService.reUrl,
				invtypeobj: LoginService.invtypeobj,
				popupName: LoginService.popupName,
				params: LoginService.params
			};
		} else {
			queryString = { reUrl: window.location.href };
		}
		ASaveQueryData(getToken, JSON.stringify(queryString));
	}
}

function getToken(res: any) {
	if (res.data) {
		window.location.href = process.env.PUBLIC_URL + "/login?token=" + res.data.token;
	}
}
